/* eslint-disable max-len, react/jsx-props-no-spreading, react/prop-types, react/destructuring-assignment */
import React from 'react';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';

const { arrayOf, shape, string } = proptypes;

const placeholder = (
  <Skeleton>
    <SkeletonBlock aspect="wide" />
  </Skeleton>
);

const RecommendedSearchesImport = withDynamicImport({
  server: () => {
    return (<></>);
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "message-types" */
      './index'
    );
  },
  placeholder,
  name: 'RecommendedSearches'
});

export const RecommendedSearchesImporter = withErrorBoundary(RecommendedSearchesImport);

RecommendedSearchesImporter.displayName = 'RecommendedSearchesImporter';

RecommendedSearchesImporter.propTypes = {
  categories: arrayOf(shape({
    imageUrl: string,
    href: string,
    searchTerm: string,
    category: arrayOf(string)
  })).isRequired
};

const AssistantRecommendationsImport = withDynamicImport({
  server: () => {
    return (<></>);
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "message-types" */
      './index'
    );
  },
  placeholder,
  name: 'AssistantRecommendations'
});

export const AssistantRecommendationsImporter = withErrorBoundary(AssistantRecommendationsImport);

AssistantRecommendationsImporter.displayName = 'AssistantRecommendationsImporter';

AssistantRecommendationsImporter.propTypes = {
  products: arrayOf(shape({
    itemId: string
  })).isRequired
};

const ExceptionMessageImport = withDynamicImport({
  server: () => {
    return (<></>);
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "message-types" */
      './index'
    );
  },
  placeholder,
  name: 'ExceptionMessage'
});

export const ExceptionMessageImporter = withErrorBoundary(ExceptionMessageImport);

ExceptionMessageImporter.displayName = 'ExceptionMessageImporter';

ExceptionMessageImporter.propTypes = {
  data: shape({
    telephoneNumber: string,
    description: string,
    referenceUrl: string
  }).isRequired,
};

const ATCConfirmationImport = withDynamicImport({
  server: () => {
    return (<></>);
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "message-types" */
      './index'
    );
  },
  placeholder,
  name: 'ATCConfirmation'
});

export const ATCConfirmationImporter = withErrorBoundary(ATCConfirmationImport);

ATCConfirmationImporter.displayName = 'ATCConfirmationImporter';

ATCConfirmationImporter.propTypes = {
  itemId: string.isRequired
};
